module.exports = () => {
  return {
    /** 视频发布时间 */
    video_publish_time: {
      label: '视频发布时间',
      type: 'date-picker',
      value: [],
      props: {
        type: 'daterange',
        valueFormat: 'yyyy-MM-dd',
        startPlaceholder: '请选择开始日期',
        endPlaceholder: '请选择结束日期',
      },
    },
  };
};
